import dayjs from "dayjs";
import { get, increment, ref, update } from "firebase/database";
import { authentication, database } from "../../../configs";
import { getMenuContext } from "../helpers";

// childPath examples: "menu_views", `products/${id}`, `categories/${id}`,
// `sections/${id}`, "events/search_used"
export const incrementMenuStat = async (childPath) => {
  try {
    const { userID, establishmentID } = getMenuContext();
    if (!userID || !establishmentID || !childPath) return;
    // The owner browsing their own menu should not inflate the stats
    if (authentication.currentUser?.uid === userID) return;

    // Capture the date before the async check so a read that resolves after
    // midnight still counts toward the day the interaction happened
    const dateKey = dayjs().format("YYYY-MM-DD");
    const establishmentPath = `${userID}/Establishments/${establishmentID}`;
    // Writing stats for a deleted establishment or a wrong link would create
    // a phantom establishment containing only Statistics
    const establishmentIdSnapshot = await get(
      ref(database, `${establishmentPath}/id`),
    );

    if (!establishmentIdSnapshot.exists()) return;

    const statsRef = ref(
      database,
      `${establishmentPath}/Statistics/${dateKey}`,
    );
    await update(statsRef, { [childPath]: increment(1) });
  } catch (error) {
    window.console.warn("statistics:", error);
  }
};

export const incrementMenuViewStat = () => {
  try {
    const { userID, establishmentID } = getMenuContext();
    const sessionKey = `stats_menu_view_${userID}_${establishmentID}`;
    if (sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, "1");
  } catch (error) {
    // sessionStorage unavailable — count the view anyway
    window.console.warn("statistics:", error);
  }
  incrementMenuStat("menu_views");
};
